class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        // console.log(parsedState,"parse");
        // this.cartNotification.renderContents(parsedState);
        $("#cart_reload").load("#cart_reload .cart_content > *",function () {
          let s_popup = $("<div>").attr("class", "s_popup").html(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1718590754310" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="4247" width="200" height="200"><path d="M514.048 59.392q93.184 0 174.592 35.328t142.336 96.768 96.256 143.36 35.328 175.104-35.328 175.616-96.256 143.872-142.336 96.768-174.592 35.328-175.104-35.328-142.848-96.768-96.256-143.872-35.328-175.616 35.328-175.104 96.256-143.36 142.848-96.768 175.104-35.328zM795.648 423.936q18.432-18.432 19.456-45.568t-17.408-45.568-45.056-17.92-45.056 18.944l-288.768 288.768-99.328-98.304q-18.432-18.432-45.056-18.944t-45.056 17.92-18.944 43.52 17.92 43.52l142.336 143.36q18.432 18.432 48.128 17.92t48.128-18.944l-4.096 4.096z" p-id="4248" fill="#36ab60"/></svg> 1 Item added to cart. `);
          $("body").append(s_popup);
          s_popup.css({
            'opacity': 0,
            'top': '44%'
          });
          s_popup.animate({
            'opacity': 1,
            'top': '49%'
          }, 200);
          setTimeout(function() {
            s_popup.animate({
              'opacity': 0,
              'top': '44%'
            }, 200, function() {
              s_popup.remove();
            });
          }, 2000);
          $(".cart-content").addClass('active');
          $(".overlay").addClass('overlay_active');
        });
        $(".cart-count-bubble").load(" .cart-count-bubble > *");
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
